import { component } from 'picoapp'
import Flickity from 'flickity'

export default component(() => {
  const slideshow = document.querySelector('.js-slider')
  const thumbs = document.querySelectorAll('.slider__thumbs')

  const fl = new Flickity(slideshow, {
    contain: true,
    pageDots: false,
    draggable: false,
    autoPlay: 3000,
    prevNextButtons: false
  })

  setTimeout(() => {
    fl.resize()
  }, 1000)

  fl.on('select', () => {
    thumbs.forEach((thumb) => {
      thumb.classList.remove('active')
    })
    thumbs[fl.selectedIndex].classList.add('active')
  })

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((thumb) => {
        thumb.classList.remove('active')
      })
      thumb.classList.add('active')
      fl.select(i)
    })
  })
})
